export const getObjectVal = (val, obj) => {
  return obj.filter(e => e.dictionaryId === val).length ? obj.filter(e => e.dictionaryId === val)[0].showName : ''
}
